module.exports = __webpack_public_path__ + "static/media/cover-live.ea54e35c.png";